import LegalLayout from "./LegalLayout";

// Reemplaza estos placeholders por capturas reales cuando las tengas:
// import screenshot1 from "../../assets/images/legal/screenshot-1.png";
// y usa <img src={screenshot1} alt="..." /> dentro del div.screenshotSlot correspondiente.
// const SCREENSHOT_LABELS = [
//   "Calendario de tareas",
//   "Detalle de tarea",
//   "Cronómetro",
//   "Notificaciones",
// ];

export default function AppInfo() {
  return (
    <LegalLayout>
      <h1>Magec</h1>
      <p className="legalLead">
        Magec es la app de Metropolis para la gestión diaria de tareas:
        calendario de trabajo, seguimiento de tiempo por tarea y
        notificaciones para el equipo.
      </p>

      {/* <div className="screenshotGrid">
        {SCREENSHOT_LABELS.map((label) => (
          <div className="screenshotSlot" key={label}>
            <span>{label}</span>
          </div>
        ))}
      </div> */}

      <h2>Qué incluye</h2>
      <div className="featureList">
        <div className="featureCard">
          <h3>Calendario de tareas</h3>
          <p>Vista mensual con la carga de trabajo asignada cada día.</p>
        </div>
        <div className="featureCard">
          <h3>Cronómetro</h3>
          <p>Registra el tiempo real dedicado a cada tarea.</p>
        </div>
        <div className="featureCard">
          <h3>Reasignación</h3>
          <p>Solicita o reasigna tareas entre compañeros del equipo.</p>
        </div>
        <div className="featureCard">
          <h3>Notificaciones</h3>
          <p>Avisos push cuando algo cambia en tus tareas.</p>
        </div>
      </div>

      <h2>Cómo acceder</h2>
      <p>
        El acceso se realiza con la cuenta que te proporciona tu
        organización.
      </p>
    </LegalLayout>
  );
}
